<svg
  [attr.width]="width()"
  [attr.height]="height()"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  [attr.stroke-width]="strokeWidth()"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  focusable="false"
>
  <!-- Plus Icon -->
  @if (name() === 'plus') {
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  }

  <!-- Close Icon -->
  @if (name() === 'close') {
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  }

  <!-- Edit Icon -->
  @if (name() === 'edit') {
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  }

  <!-- Delete Icon -->
  @if (name() === 'delete') {
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  }

  <!-- Search Icon -->
  @if (name() === 'search') {
    <circle cx="11" cy="11" r="8"></circle>
    <path d="m21 21-4.35-4.35"></path>
  }

  <!-- Chevron Down -->
  @if (name() === 'chevron-down') {
    <polyline points="6 9 12 15 18 9"></polyline>
  }

  <!-- Chevron Up -->
  @if (name() === 'chevron-up') {
    <polyline points="18 15 12 9 6 15"></polyline>
  }

  <!-- Chevron Left -->
  @if (name() === 'chevron-left') {
    <polyline points="15 18 9 12 15 6"></polyline>
  }

  <!-- Chevron Right -->
  @if (name() === 'chevron-right') {
    <polyline points="9 18 15 12 9 6"></polyline>
  }

  <!-- Checkmark -->
  @if (name() === 'checkmark') {
    <polyline points="20 6 9 17 4 12"></polyline>
  }

  <!-- Clear (X in circle) -->
  @if (name() === 'clear') {
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="15" y1="9" x2="9" y2="15"></line>
    <line x1="9" y1="9" x2="15" y2="15"></line>
  }

  <!-- Copy/Duplicate Icon -->
  @if (name() === 'copy') {
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
  }

  <!-- Dollar Icon -->
  @if (name() === 'dollar') {
    <line x1="12" y1="1" x2="12" y2="23"></line>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
  }

  <!-- Eye Icon -->
  @if (name() === 'eye') {
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  }

  <!-- Info Icon -->
  @if (name() === 'info') {
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  }

  <!-- Arrow Right Icon -->
  @if (name() === 'arrow-right') {
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  }

  <!-- Arrow Left Icon -->
  @if (name() === 'arrow-left') {
    <path d="M19 12H5"></path>
    <path d="M12 19l-7-7 7-7"></path>
  }

  <!-- Refresh Icon -->
  @if (name() === 'refresh') {
    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
    <path d="M21 3v5h-5"></path>
    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
    <path d="M3 21v-5h5"></path>
  }

  <!-- Users Icon -->
  @if (name() === 'users') {
    <circle cx="9" cy="7" r="4" />
    <path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" />
    <circle cx="19" cy="7" r="2" />
    <path d="M23 21v-1a2 2 0 00-2-2h-2" />
  }

  <!-- Upload Icon -->
  @if (name() === 'upload') {
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="17 8 12 3 7 8"></polyline>
    <line x1="12" y1="3" x2="12" y2="15"></line>
  }

  <!-- Alert Circle Icon -->
  @if (name() === 'alert-circle') {
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  }

  <!-- Image Icon -->
  @if (name() === 'image') {
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <circle cx="8.5" cy="8.5" r="1.5"></circle>
    <polyline points="21,15 16,10 5,21"></polyline>
  }

  <!-- Camera Icon -->
  @if (name() === 'camera') {
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
    <circle cx="12" cy="13" r="4"></circle>
  }

  <!-- Grid Icon -->
  @if (name() === 'grid') {
    <rect x="3" y="3" width="7" height="7" rx="1"></rect>
    <rect x="14" y="3" width="7" height="7" rx="1"></rect>
    <rect x="3" y="14" width="7" height="7" rx="1"></rect>
    <rect x="14" y="14" width="7" height="7" rx="1"></rect>
  }

  <!-- Building Icon -->
  @if (name() === 'building') {
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  }

  <!-- Map Pin Icon -->
  @if (name() === 'map-pin') {
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  }

  <!-- User Icon -->
  @if (name() === 'user') {
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  }

  <!-- Settings Icon -->
  @if (name() === 'settings') {
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M12 1v6m0 6v6m8.66-10l-5.2 3m-3.46 2l-5.2 3m0-12l5.2 3m3.46 2l5.2 3"></path>
  }

  <!-- Box/Empty State Icon -->
  @if (name() === 'box') {
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="9" y1="3" x2="9" y2="21"></line>
  }

  <!-- Download Icon -->
  @if (name() === 'download') {
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  }

  <!-- Check Circle Icon -->
  @if (name() === 'check-circle') {
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="16 8 10 14 8 12"></polyline>
  }

  <!-- Navigation / Directions Icon -->
  @if (name() === 'navigation') {
    <polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>
  }

  <!-- Clock Icon -->
  @if (name() === 'clock') {
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  }

  <!-- X Circle Icon -->
  @if (name() === 'x-circle') {
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="15" y1="9" x2="9" y2="15"></line>
    <line x1="9" y1="9" x2="15" y2="15"></line>
  }

  <!-- Send Icon -->
  @if (name() === 'send') {
    <line x1="22" y1="2" x2="11" y2="13"></line>
    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
  }

  <!-- Credit Card Icon -->
  @if (name() === 'credit-card') {
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
    <line x1="1" y1="10" x2="23" y2="10"></line>
  }

  <!-- File Icon -->
  @if (name() === 'file') {
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
  }

  <!-- More Vertical Icon (three dots) -->
  @if (name() === 'more-vertical') {
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="12" cy="5" r="1"></circle>
    <circle cx="12" cy="19" r="1"></circle>
  }

  <!-- Home Icon -->
  @if (name() === 'home') {
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  }

  <!-- List Icon -->
  @if (name() === 'list') {
    <line x1="8" y1="6" x2="21" y2="6"></line>
    <line x1="8" y1="12" x2="21" y2="12"></line>
    <line x1="8" y1="18" x2="21" y2="18"></line>
    <line x1="3" y1="6" x2="3.01" y2="6"></line>
    <line x1="3" y1="12" x2="3.01" y2="12"></line>
    <line x1="3" y1="18" x2="3.01" y2="18"></line>
  }

  <!-- File Text Icon -->
  @if (name() === 'file-text') {
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  }

  <!-- Star Icon -->
  @if (name() === 'star') {
    <polygon
      points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
    ></polygon>
  }

  <!-- Calendar Icon -->
  @if (name() === 'calendar') {
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  }

  <!-- Package Icon -->
  @if (name() === 'package') {
    <line x1="16.5" y1="9.4" x2="7.55" y2="4.24"></line>
    <path
      d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
    ></path>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
    <line x1="12" y1="22.08" x2="12" y2="12"></line>
  }

  <!-- Layers Icon -->
  @if (name() === 'layers') {
    <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
    <polyline points="2 17 12 22 22 17"></polyline>
    <polyline points="2 12 12 17 22 12"></polyline>
  }

  <!-- Trending Up Icon -->
  @if (name() === 'trending-up') {
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
    <polyline points="17 6 23 6 23 12"></polyline>
  }

  <!-- Bar Chart Icon -->
  @if (name() === 'bar-chart') {
    <line x1="18" y1="20" x2="18" y2="10"></line>
    <line x1="12" y1="20" x2="12" y2="4"></line>
    <line x1="6" y1="20" x2="6" y2="14"></line>
  }

  <!-- Gift Icon -->
  @if (name() === 'gift') {
    <polyline points="20 12 20 22 4 22 4 12"></polyline>
    <rect x="2" y="7" width="20" height="5"></rect>
    <line x1="12" y1="22" x2="12" y2="7"></line>
    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
  }

  <!-- Phone Icon -->
  @if (name() === 'phone') {
    <path
      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 11 19.79 19.79 0 0 1 1.61 2.37a2 2 0 0 1 1.9-2.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 7.91a16 16 0 0 0 6.1 6.1l.91-.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 15z"
    ></path>
  }

  <!-- Mail Icon -->
  @if (name() === 'mail') {
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  }

  <!-- Printer Icon -->
  @if (name() === 'printer') {
    <polyline points="6 9 6 2 18 2 18 9"></polyline>
    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
    <rect x="6" y="14" width="12" height="8"></rect>
  }

  <!-- Award Icon -->
  @if (name() === 'award') {
    <circle cx="12" cy="8" r="7"></circle>
    <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
  }

  <!-- Sliders Icon -->
  @if (name() === 'sliders') {
    <line x1="4" y1="21" x2="4" y2="14"></line>
    <line x1="4" y1="10" x2="4" y2="3"></line>
    <line x1="12" y1="21" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12" y2="3"></line>
    <line x1="20" y1="21" x2="20" y2="16"></line>
    <line x1="20" y1="12" x2="20" y2="3"></line>
    <line x1="1" y1="14" x2="7" y2="14"></line>
    <line x1="9" y1="8" x2="15" y2="8"></line>
    <line x1="17" y1="16" x2="23" y2="16"></line>
  }

  <!-- Bell Icon -->
  @if (name() === 'bell') {
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
  }

  <!-- Scan / QR Icon -->
  @if (name() === 'scan') {
    <path d="M4 8V5a1 1 0 0 1 1-1h3"></path>
    <path d="M16 4h3a1 1 0 0 1 1 1v3"></path>
    <path d="M4 16v3a1 1 0 0 0 1 1h3"></path>
    <path d="M16 20h3a1 1 0 0 0 1-1v-3"></path>
    <line x1="4" y1="12" x2="20" y2="12"></line>
  }

  <!-- Menu (Hamburger) Icon -->
  @if (name() === 'menu') {
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  }

  <!-- Cart Icon -->
  @if (name() === 'cart') {
    <circle cx="9" cy="21" r="1"></circle>
    <circle cx="20" cy="21" r="1"></circle>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
  }

  <!-- Bronze Icon -->
  @if (name() === 'shield') {
    <circle cx="12" cy="8" r="7"></circle>
    <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
    <circle cx="12" cy="8" r="3"></circle>
  }

  <!-- Platinum Icon -->
  @if (name() === 'gem') {
    <polygon points="12 2 22 7 22 17 12 22 2 17 2 7"></polygon>
    <polygon points="12 6 18 9.5 18 14.5 12 18 6 14.5 6 9.5"></polygon>
  }

  <!-- Shield Lock Icon -->
  @if (name() === 'shield-lock') {
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <rect x="9" y="11" width="6" height="5" rx="1"></rect>
    <path d="M10 11V9a2 2 0 1 1 4 0v2"></path>
  }

  <!-- Eye Off Icon -->
  @if (name() === 'eye-off') {
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"></path>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"></path>
    <line x1="1" y1="1" x2="23" y2="23"></line>
  }

  <!-- Lock Icon -->
  @if (name() === 'lock') {
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
  }
</svg>
